import { ILayer, ILabel } from '../../../types/common';
import popup from '../popup/index';

const source = 'courses';

const config = {
  id: source,
  type: 'fill',
  source,
  layout: {
    visibility: 'visible',
  },
  paint: {
    'fill-color': '#CCC',
    'fill-opacity': 0.2,
  },
};

const border = {
  id: `${source}-border`,
  type: 'line',
  source,
  paint: {
    'line-color': '#fff',
    'line-width': 1,
  },
};

const load = async ({ courseId = null }): Promise<ILayer> => {
  const url = ['/geojson/courses', courseId ? `course_id=${courseId}` : null]
    .filter(Boolean)
    .join('?');
  const response = await fetch(url);
  const data = await response.json();

  const courses = {
    ...data,
    features: data.features.map((feature) => ({
      ...feature,
      properties: {
        ...feature.properties,
        popup: popup.course({
          name: feature.properties.name,
          acres: feature.properties.acres,
        }),
      },
    })),
  };

  const labels: ILabel[] = data.features.map((f) => ({
    text: f.properties.name,
    coordinates: [f.properties.longitude, f.properties.latitude],
  }));

  return {
    data: courses,
    config,
    source,
    labels,
    markers: null,
    sublayers: [border],
    popup: true,
  };
};

export default load;
